(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["twl-plant-collection"]) return;
  try {
    
function twlInitPlantFilters(scope) {
  scope.querySelectorAll('[data-twl-plants]').forEach(root => {
    if (root.dataset.twlReady) return;
    root.dataset.twlReady = 'true';
    const panel = root.querySelector('[data-twl-filter-panel]');
    const form = root.querySelector('form');
    const sort = root.querySelector('[data-twl-sort]');
    const hiddenSort = root.querySelector('[data-twl-sort-value]');
    const media = window.matchMedia('(max-width: 989px)');
    const sizePanel = () => { panel.open = !media.matches; };
    sizePanel();
    media.addEventListener('change', sizePanel);
    sort.addEventListener('change', () => { hiddenSort.value = sort.value; form.requestSubmit(); });
    form.addEventListener('submit', () => {
      hiddenSort.value = sort.value;
      sort.disabled = true;
      form.querySelectorAll('input[type="number"]').forEach(input => { if (input.value === '') input.disabled = true; });
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => twlInitPlantFilters(document));
else twlInitPlantFilters(document);
document.addEventListener('shopify:section:load', event => twlInitPlantFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["twl-substrate-guide"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const copy = JSON.parse(root.querySelector('[data-copy]').textContent);
    const fields = Object.fromEntries(Array.from(form.elements).filter(field => field.name).map(field => [field.name, field]));
    const presets = {45:[45,27],60:[60,30],75:[75,35],90:[90,45],120:[120,45],150:[150,60],'20long':[76.2,30.48],'40breeder':[91.44,45.72]};
    const productSelect = root.querySelector('#sg-product');
    const productOptions = Array.from(productSelect.options).slice(1).map(option=>option.cloneNode(true));
    const filterProducts = () => {
      const chosen=productSelect.value;
      while(productSelect.options.length>1)productSelect.remove(1);
      productOptions.filter(option=>option.dataset.kind===fields.material.value).forEach(option=>productSelect.add(option.cloneNode(true)));
      productSelect.value=Array.from(productSelect.options).some(option=>option.value===chosen)?chosen:'';
    };
    const sizesFrom = option => {
      if(!option || !option.value)return [];
      const titles=JSON.parse(option.dataset.variants || '[]');
      const labels=titles.filter(title=>title!=='Default Title');
      if(!labels.length)labels.push(option.dataset.title || '');
      return [...new Map(labels.map(label=>{
        const match=label.match(/(\d+(?:\.\d+)?)\s*(ml|kg|litres?|liters?|l)\b/i);
        if(!match)return null;
        const value=Number(match[1]);const unit=match[2].toLowerCase();
        const item={size:unit==='ml'?value/1000:value,unit:unit==='kg'?'kg':'L'};
        return [item.size+item.unit,item];
      }).filter(Boolean)).values()];
    };
    let oldUnit = 'cm';
    let canonicalDimensions = null;
    const number = value => new Intl.NumberFormat(document.documentElement.lang || 'en',{maximumFractionDigits:2}).format(value);
    const format = (key, values) => Object.entries(values).reduce((text,[name,value])=>text.replaceAll('{'+name+'}',value),copy[key]);
    const result = (selector,text) => {root.querySelector(selector).textContent=text;};
    const calculate = () => {
      const values = ['length','width','front','back','coverage'].map(name=>Number(fields[name].value));
      const error = root.querySelector('.sg-error');
      if (values.some(v=>!Number.isFinite(v)||v<=0) || values[4]>100 || !form.checkValidity()) {error.hidden=false;return false;}
      error.hidden=true;
      const factor = fields.units.value==='inch' ? 2.54 : 1;
      const [length,width,front,back] = canonicalDimensions || values.slice(0,4).map(v=>v*factor);
      const base = length*width*(front+back)/2/1000*values[4]/100;
      const total = base*(fields.extra.checked?1.1:1);
      const kind=fields.material.value;
      const selected=productSelect.selectedOptions[0];
      const material={density:kind==='sand'?1.6:kind==='gravel'?1.5:null,url:selected?.dataset.url};
      const bagSizes=sizesFrom(selected);
      result('[data-selected-product]',selected?.dataset.title||'');
      result('[data-total]',number(total));
      result('[data-base]',format('base',{base:number(base),allowance:fields.extra.checked?copy.with_allowance:copy.no_allowance}));
      const quantity=material.density?total*material.density:total;
      result('[data-bags]',bagSizes.length?bagSizes.filter(bag=>bag.unit==='L'||material.density).map(bag=>format('bags',{count:Math.ceil((bag.unit==='kg'?quantity:total)/bag.size-1e-10),size:bag.size,unit:bag.unit})).join(' '+copy.or+' '):copy.no_bags);
      result('[data-weight]',material.density?format('weight',{weight:number(quantity),density:material.density}):copy.soil_weight);
      result('[data-material-note]',kind==='powder'?copy.powder:kind==='base'?copy.base_note:kind==='paludarium'?copy.paludarium_note:material.density?copy.density_note:copy.soil_note);
      root.querySelector('[data-shop]').href=material.url||'/collections/substrate-system';
      const max=Math.max(front,back)*1.5;
      const yFront=160-front/max*105, yBack=160-back/max*105;
      root.querySelector('[data-bed]').setAttribute('d',`M40 ${yFront} 360 ${yBack}v${160-yBack}H40Z`);
      root.querySelector('[data-bed-line]').setAttribute('d',`M40 ${yFront} 360 ${yBack}`);
      result('[data-front-label]',number(values[2])+' '+(factor===1?'cm':'in'));
      result('[data-back-label]',number(values[3])+' '+(factor===1?'cm':'in'));
      root.querySelector('[data-front-label]').setAttribute('y',Math.max(30,yFront-10));
      root.querySelector('[data-back-label]').setAttribute('y',Math.max(30,yBack-10));
      return true;
    };
    form.addEventListener('submit',event=>{event.preventDefault();calculate();});
    fields.units.addEventListener('change',()=>{
      const next=fields.units.value;
      if (!canonicalDimensions) canonicalDimensions = ['length','width','front','back'].map(name => Number(fields[name].value) * (oldUnit === 'inch' ? 2.54 : 1));
      ['length','width','front','back'].forEach((name,index)=>fields[name].value=Number((canonicalDimensions[index]/(next==='inch'?2.54:1)).toFixed(3)));
      root.querySelectorAll('[data-unit]').forEach(node=>node.textContent=next==='cm'?'cm':'in');
      oldUnit=next;calculate();
    });
    fields.preset.addEventListener('change',()=>{
      const preset=presets[fields.preset.value];
      if(!preset)return;
      canonicalDimensions = null;
      const factor=fields.units.value==='inch'?1/2.54:1;
      fields.length.value=Number((preset[0]*factor).toFixed(6));fields.width.value=Number((preset[1]*factor).toFixed(6));calculate();
    });
    ['length','width','front','back'].forEach(name=>fields[name].addEventListener('input',()=>{canonicalDimensions=null;if(['length','width'].includes(name))fields.preset.value='';}));
    form.addEventListener('change',event=>{if(event.target.name==='material')filterProducts();if(!['preset','units'].includes(event.target.name))calculate();});
    filterProducts();calculate();
  };
  const mount=()=>document.querySelectorAll('[data-substrate-guide]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
})();


  } catch(e) { console.error(e); }
})();
})();
